import { UnionMap } from '../types/union-map';

export type LongRunningOperationStatus = 'Succeeded' | 'Failed' | 'Running';
export const LongRunningOperationStatus: UnionMap<LongRunningOperationStatus> = {
    Succeeded: 'Succeeded',
    Failed: 'Failed',
    Running: 'Running',
};
